import { LucideBugPlay } from "lucide-react";
import styles from "./ParserDebugButton.module.css";
import { positionType } from "./ViewerLayoutTypes";
import { zIndex } from "../api/CommonConstants";

export const ParserDebugButton = ({ x, y, onClick }: positionType & { onClick?: () => void }) => {
  return (
    <LucideBugPlay
      className={styles.debugButton}
      style={{
        zIndex: zIndex.zIndexViewerToolsFocused,
        top: y,
        left: x,
      }}
      onClick={onClick}
    />
  );
};
